const _ = (data: any) => {
  const product = {
    id: `${data.manufacturerCode} ${data.partNumber}`,
    quantity: data.returnQuantity,
    revenue: data.price * data.returnQuantity,
    reason: data.reason
  };
  return product;
};

export default (
  data: any,
  event: string,
  rmaNumber: string,
  returnOption: string
) => {
  const dataLayerObject = _(data);
  return {
    event,
    rma: {
      product: {
        partNumber: dataLayerObject.id,
        returnOption,
        quantity: dataLayerObject.quantity,
        returnNumber: rmaNumber,
        revenue: dataLayerObject.revenue,
        returnReason: dataLayerObject.reason
      }
    }
  };
};
